import { render } from "./RecurringGivingOption.vue?vue&type=template&id=50da867b"
import script from "./RecurringGivingOption.vue?vue&type=script&lang=js"
export * from "./RecurringGivingOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__